module.exports = __webpack_public_path__ + "img/pdf.dedce392.png";